import React, { useEffect, useState } from "react";
import { Grid, IconButton, TextField } from "@mui/material";
import { useRef } from "react";
import { useMediaQuery } from "react-responsive";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDAvatar from "components/MDAvatar";
import MDTypography from "components/MDTypography";
import { getUserInfo } from "services/apiService";
import { resetPassword } from "services/userService";
import { updateUser } from "services/apiService";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import validations from "customValidations/validations";
import validationService from "customValidations/validationService";
import CameraAltOutlinedIcon from "@mui/icons-material/CameraAltOutlined";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { updateUserBackground } from "services/apiService";
import { useDispatch, useSelector } from "react-redux";
import SpinLoader from "components/SpinLoader";
import { fetchCurrentUserInfo } from "Store/slices/userInfoSlice";

const EditProfile = () => {
  const dispatch = useDispatch();
  let navigate = useNavigate();

  const { userAppInfo, isLoadingInfo } = useSelector((state) => state.userInfo);

  const inputFile = useRef(null);
  const inputFile2 = useRef(null);
  const [userInfo, setUserInfo] = useState("");
  const [accountType, setAccountType] = useState("");
  const [name, setName] = useState("");
  const [username, setUsername] = useState("");
  const [bio, setBio] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [img, setImg] = useState("");
  const [imgSrc, setImgSrc] = useState("");
  const [bgImg, setBgImg] = useState("");
  const [bgImgSrc, setBgImgSrc] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [errorMsg, setErrorMsg] = useState({
    name: { errorMsg: "" },
    username: { errorMsg: "" },
    bio: { errorMsg: "" },
    password: { errorMsg: "" },
  });

  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const isBigScreen = useMediaQuery({ query: "(min-width: 1824px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

  useEffect(() => {
    fetchUserInfo();
  }, [userAppInfo]);

  const fetchUserInfo = async () => {
    // const userInfoRes = await getUserInfo(
    //   localStorage.getItem("userNameSingh")
    // );
    // console.log("Test", userAppInfo);
    setUserInfo(userAppInfo);
    setAccountType(userAppInfo.accountType);
    setBgImgSrc(userAppInfo.backgroundImage);
    setImgSrc(userAppInfo.profilePic);
    setName(userAppInfo.fullName);
    setUsername(userAppInfo.username);
    setBio(userAppInfo.bio);
    setEmail(userAppInfo.email);
  };

  const handleBackgroundClick = () => {
    inputFile2.current.click();
  };

  const handleProfileClick = () => {
    inputFile.current.click();
  };

  const handleBrowse2 = (e) => {
    setBgImg(e.target.files[0]);
    var file = e.target.files[0];
    var reader = new FileReader();
    var url = reader.readAsDataURL(file);

    reader.onloadend = function (e) {
      setBgImgSrc(reader.result);
    };
  };

  const handleBrowse = (e) => {
    setImg(e.target.files[0]);
    var file = e.target.files[0];
    var reader = new FileReader();
    var url = reader.readAsDataURL(file);

    reader.onloadend = function (e) {
      setImgSrc(reader.result);
    };
  };

  const customValidations = (name, value) => {
    let errorLength = 0;
    const args = [
      {
        name,
        value: value,
        validations: validations.editProfileValidations[name],
      },
    ];

    validationService.validate(args, (validationErr, validationErrMsgs) => {
      if (validationErrMsgs.length > 0) {
        errorLength = errorLength + 1;
        errorMsg[name].errorMsg = validationErrMsgs[0].validations[0].message;
        setErrorMsg({ ...errorMsg });
      } else {
        errorMsg[name].errorMsg = "";
        setErrorMsg({ ...errorMsg });
      }
    });
    return errorLength;
  };

  const handleInputChange = (name, value) => {
    if (name === "name") {
      setName(value);
    } else if (name === "username") {
      setUsername(value);
    } else if (name === "bio") {
      setBio(value);
    } else if (name === "select") {
      setCountryCode(value);
    } else if (name === "password") {
      setPassword(value);
    } else if (name === "confirmPassword") {
      setConfirmPassword(value);
    }
  };

  const handleChangePassword = async () => {
    let errorLengthPassword = customValidations("password", password);

    if (errorLengthPassword === 1) {
      return;
    }

    // console.log("pass", password);
    // console.log("passc", confirmPassword);

    if (password !== confirmPassword) {
      // Swal.fire("", "Confirm Password doesn't match with password", "error");
      toast.warning(`Confirm Password doesn't match with password`, {
        style: {
          fontSize: "15px",
        },
      });
      return;
    }

    const passwordData = {
      email: email,
      password: password,
      confirmPassword: confirmPassword,
    };

    const changePasswordRes = await resetPassword(passwordData);
    // console.log("changePass", changePasswordRes);
  };

  const handleUpdate = async () => {
    let errorLengthName = customValidations("name", name);
    // let errorLengthUsername = customValidations("username", username);
    let errorLengthBio = customValidations("bio", bio);
    // console.log("er", errorLengthName);
    if (
      errorLengthName === 1 ||
      // errorLengthUsername === 1 &&
      errorLengthBio === 1
    ) {
      // console.log("er", errorLengthName);
      return;
    }

    if (bgImg != "") {
      let updateBackGroundImg = new FormData();

      updateBackGroundImg.append("background", bgImg);
      const updateBackGroundImgRes = await updateUserBackground(
        updateBackGroundImg
      );
      // console.log("upBG", updateBackGroundImgRes);
    }

    let updateData = new FormData();

    updateData.append("fullName", name);
    // updateData.append("username", username);
    updateData.append("bio", bio);
    updateData.append("profile", img);

    const updateDataRes = await updateUser(updateData);

    // console.log("updateDataRes", updateDataRes);
    // Swal.fire("Saved successfully", "", "success");
    if (updateDataRes.status === 200) {
      dispatch(fetchCurrentUserInfo(localStorage.userNameSingh));
      toast.success(`Saved successfully`, {
        style: {
          fontSize: "15px",
        },
      });

      // navigate("/");
    }
    //  else {
    //   toast.error(`Oops something went wrong, please try again`, {
    //     style: {
    //       fontSize: "15px",
    //     },
    //   });
    // }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {!isLoadingInfo ? (
        <MDBox sx={{}}>
          <MDBox
            sx={{
              height: "400px",
              backgroundImage: `url(${bgImgSrc})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "100% 100%",
              backgroundPosition: "center",
              display: "flex",
              justifyContent: "right",
              alignItems: "flex-start",
            }}
          >
            <MDInput
              style={{ display: "none" }}
              type="file"
              inputProps={{ ref: inputFile2, accept: "image/*" }}
              onChange={(e) => handleBrowse2(e)}
            />
            {/* <MDButton onClick={() => handleBackgroundClick()}>
            Change background
          </MDButton> */}
            <IconButton
              sx={{
                alignItems: "end",
                position: "absolute",
                fontSize: "25px",
                backgroundColor: "#000",
                // top: isDesktopOrLaptop ? "36%" : "38%",
                // left: isDesktopOrLaptop ? "51%" : "35%",
                // height: isDesktopOrLaptop ? "200px" : "100px",
                // width: isDesktopOrLaptop ? "200px" : "100px",
                cursor: "pointer",
              }}
              onClick={() => handleBackgroundClick()}
            >
              <ModeEditOutlineOutlinedIcon style={{ color: "#fff" }} />
            </IconButton>
            <MDInput
              style={{ display: "none" }}
              type="file"
              inputProps={{ ref: inputFile, accept: "image/*" }}
              onChange={(e) => handleBrowse(e)}
            />
            <MDAvatar
              src={imgSrc}
              alt="profilePic"
              sx={{
                position: "absolute",
                top: isDesktopOrLaptop ? "35%" : "35%",
                left: isDesktopOrLaptop ? "45%" : "35%",
                height: isDesktopOrLaptop ? "200px" : "100px",
                width: isDesktopOrLaptop ? "200px" : "100px",
                cursor: "pointer",
              }}
              imgProps={{ style: { height: "100%", width: "100%" } }}
              onClick={() => handleProfileClick()}
            ></MDAvatar>
            <IconButton
              sx={{
                // border: "1px solid #6a6a6a",
                alignItems: "end",
                position: "absolute",
                // fontSize: "45px",
                top: isDesktopOrLaptop ? "36%" : "35%",
                left: isDesktopOrLaptop ? "51%" : "45%",
                height: isDesktopOrLaptop ? "200px" : "100px",
                width: isDesktopOrLaptop ? "200px" : "100px",
                cursor: "pointer",
              }}
              onClick={() => handleProfileClick()}
              aria-label="add to favorites"
            >
              <MDTypography fontSize="40px" color="text">
                <CameraAltOutlinedIcon />
              </MDTypography>
            </IconButton>

            {/* <MDAvatar
          src={CameraAltOutlinedIcon}
          alt="camera"
           /> */}
          </MDBox>

          <MDBox sx={{ padding: "2rem" }}>
            <MDBox>
              <MDTypography fontWeight="bold" fontSize="30px">
                Edit Profile
              </MDTypography>
              <MDTypography fontWeight="bold" fontSize="20px">
                {accountType}
              </MDTypography>
            </MDBox>
          </MDBox>
          <Grid container sx={{ gap: "2rem", padding: "1rem" }}>
            <Grid item container xs={12} md={4} gap="2rem">
              <MDBox sx={{ width: "100%" }}>
                {/* <MDTypography>Name</MDTypography> */}
                <TextField
                  fullWidth
                  name="name"
                  label="Name"
                  value={name}
                  error={errorMsg.name.errorMsg.length > 0}
                  onChange={(e) =>
                    handleInputChange(e.target.name, e.target.value)
                  }
                  helperText={errorMsg.name.errorMsg}
                />
              </MDBox>
              <MDBox sx={{ width: "100%" }}>
                <TextField
                  disabled
                  fullWidth
                  name="username"
                  label="Username"
                  value={username}
                  error={errorMsg.username.errorMsg.length > 0}
                  onChange={(e) =>
                    handleInputChange(e.target.name, e.target.value)
                  }
                  helperText={errorMsg.username.errorMsg}
                />
              </MDBox>
              <MDBox sx={{ width: "100%" }}>
                {/* <MDTypography>Bio</MDTypography> */}
                <TextField
                  fullWidth
                  name="bio"
                  label="Bio"
                  value={bio}
                  error={errorMsg.bio.errorMsg.length > 0}
                  onChange={(e) =>
                    handleInputChange(e.target.name, e.target.value)
                  }
                  helperText={errorMsg.bio.errorMsg}
                />
              </MDBox>
              <MDBox sx={{ width: "100%", textAlign: "center" }}>
                <MDButton
                  color="singh"
                  variant="contained"
                  onClick={() => handleUpdate()}
                >
                  Save
                </MDButton>
              </MDBox>
            </Grid>
            <Grid item container xs={12} md={4}>
              <MDBox sx={{ width: "100%" }}>
                <MDBox sx={{ marginBottom: "1rem" }}>
                  <MDTypography>Change password</MDTypography>
                  <TextField
                    fullWidth
                    name="password"
                    label="Password"
                    // placeholder="password"
                    value={password}
                    error={errorMsg.password.errorMsg.length > 0}
                    onChange={(e) =>
                      handleInputChange(e.target.name, e.target.value)
                    }
                    helperText={errorMsg.password.errorMsg}
                  />
                </MDBox>
                <MDBox sx={{ marginBottom: "1rem" }}>
                  <TextField
                    fullWidth
                    name="confirmPassword"
                    label="ConfirmPassword"
                    // placeholder="confirm password"
                    valeu={confirmPassword}
                    onChange={(e) =>
                      handleInputChange(e.target.name, e.target.value)
                    }
                  />
                </MDBox>
                <MDBox sx={{ width: "100%", textAlign: "center" }}>
                  <MDButton
                    variant="contained"
                    color="singh"
                    onClick={() => handleChangePassword()}
                  >
                    Change
                  </MDButton>
                </MDBox>
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
      ) : (
        <MDBox
          sx={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <SpinLoader />
        </MDBox>
      )}
    </DashboardLayout>
  );
};

export default EditProfile;
